export class Utils {
  public static deepCopy<T>(source: T): T {
    if (Array.isArray(source)) {
      return source.map((item) => this.deepCopy(item)) as T;
    }

    if (source instanceof Date) {
      return new Date(source.getTime()) as T;
    }
    if (source && typeof source === "object")
      Object.getOwnPropertyNames(source).reduce(
        (o, prop) => {
          Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop)!);
          o[prop] = this.deepCopy((source as { [key: string]: any })[prop]);
          return o;
        },
        Object.create(Object.getPrototypeOf(source)),
      );

    return source;
  }
}
